import trendImg1 from '../../assets/img/trend/1.jpg';
import trendImg2 from '../../assets/img/trend/2.jpg';
import categoryImg1 from '../../assets/img/category/hiclipart.png';
import categoryImg2 from '../../assets/img/category/hiclipart_1.png';
import categoryImg3 from '../../assets/img/category/hiclipart_10.png';
import categoryImg4 from '../../assets/img/category/hiclipart_15.png';
import categoryImg5 from '../../assets/img/category/hiclipart_21.png';
import Home from '../../assets/img/icon/house-fill.svg';
import Cart from '../../assets/img/icon/cart.svg';
import Auth from '../../assets/img/icon/box-arrow-in-right.svg';
import Facebook from '../../assets/img/icon/facebook.svg';
import Twitter from '../../assets/img/icon/twitter.svg';
import Instagram from '../../assets/img/icon/instagram.svg';
import IconNotFound from '../../assets/img/icon/undraw_opinion_dxp8_1.svg';
import Product1 from '../../assets/img/product/1.jpg';
import Product2 from '../../assets/img/product/2.png';
const img = {
  trendImg1,
  trendImg2,
  categoryImg1,
  categoryImg2,
  categoryImg3,
  categoryImg4,
  categoryImg5,
  Home,
  Cart,
  Auth,
  Facebook,
  Twitter,
  Instagram,
  IconNotFound,
  Product1,
  Product2,
};
export default img;
